import type { ModalFactory } from '../../../../vend-ui/types'
import { FulfillmentOutlet } from './Steps/types'
import markUnfulfilledModalTemplate from './mark-as-unfulfilled-modal.html'

/**
 * Service class for unfulfilled modals.
 *
 * @class MarkUnfulfilledModalService
 */
export class MarkUnfulfilledModalService {
  constructor(private readonly Modal: ModalFactory) {
    'ngInject'
  }

  /**
   * Open the modal responsible for handling quick cash payments.
   *
   * @method markUnfulfilled
   *
   * @return {ModalInstance} The instance of the modal.
   */
  public markUnfulfilled(allOutlets: FulfillmentOutlet[]) {
    return this.Modal({
      controller: 'markUnfulfilledModalController',
      controllerAs: '$ctrl',
      template: markUnfulfilledModalTemplate,
      outlets: allOutlets,
    })
  }
}
